import { CubeAnalyticsProvider } from '@vizit/cube';
import * as React from 'react';
import { useExpireSession } from '../../hooks/use-expire-session';
import { router } from '../../router';

interface CubeAnalyticsProps {
  children: React.ReactNode;
}

function CubeAnalytics(props: CubeAnalyticsProps) {
  const { children } = props;
  const expireSession = useExpireSession();

  const handleSessionExpired = React.useCallback(
    () => expireSession(router, router.state.location.href),
    [expireSession],
  );

  return <CubeAnalyticsProvider onSessionExpired={handleSessionExpired}>{children}</CubeAnalyticsProvider>;
}

export { CubeAnalytics };
